@use "../../scss/colors";
@use "../../scss/landing";
@use "../../scss/breakpoints";

$max-content-width: 1152px;
$standard-margin: 48px;

.questionsWrapper {
	width: 100%;
	display: flex;
	justify-content: center;
	padding: 64px 48px 24px 48px;

	@include breakpoints.md-down {
		padding: 64px 32px 24px 32px;
	}

	.questions {
		width: 100%;
		max-width: $max-content-width;
		display: flex;
		flex-direction: column;
		gap: 24px;

		.header {
			.heading {
				color: colors.$nordic_dark_grey;
				font-size: 32px;
				line-height: 44px;
				font-style: normal;
				font-weight: 350;
				margin-bottom: 16px;

				@include breakpoints.sm-down {
					font-size: 24px;
					line-height: 32px;
				}
			}
		}

		.footer {
			width: 100%;
			display: flex;
			flex-direction: column;
			align-items: center;
			margin-top: 24px;
		}
	}
}
